// restoreRedux.js
'use strict';
import {
  RESTORE_ME_DATA,
  RESTORE_OPERATION_DATA,
  RESTORE_LIST_ITEMS,
  ADD_MESSAGES,
  RESTORE_ASSET_DATA,
  RESTORE_MODALS,
  RESTORE_ROUTE_HISTORY,
  RESTORE_ORDER_DATA,
  SET_EXPIRE_TIMESTAMP,
} from '../ActionTypes.js';

/**
 * Restore redux
 * @kind action
 * @return {Promise} Action promise.
 */
const restoreRedux =
  ({ restoreState = {}, isFromServiceWorker = false, isInit = false } = {}) =>
  async dispatch => {
    if (isFromServiceWorker) {
      const { loadState } = await import('../resource/persist.js');
      restoreState = await loadState();
    }

    // The upload data in indexedDB might be outdated. Should filtered out to prevent restore outdated upload data.
    if (!isInit) {
      delete restoreState.operations?.uploadJob;
      // The blur/focus timing is different on Android from other platforms
      // (when webauthn native UI pops up),
      // so we exclude the webauthn from restoring.
      delete restoreState.operations?.webauthn;
      delete restoreState.lists;
      delete restoreState.messages;
      delete restoreState.assets;
    }

    if (restoreState.me) {
      dispatch({
        type: RESTORE_ME_DATA,
        payload: restoreState.me,
      });
    }

    if (restoreState.operations) {
      dispatch({
        type: RESTORE_OPERATION_DATA,
        payload: restoreState.operations,
      });
    }

    if (restoreState.lists) {
      dispatch({
        type: RESTORE_LIST_ITEMS,
        payload: restoreState.lists,
      });
    }

    if (restoreState.messages) {
      dispatch({
        type: ADD_MESSAGES,
        payload: {
          messages: restoreState.messages,
        },
      });
    }

    if (restoreState.assets) {
      dispatch({
        type: RESTORE_ASSET_DATA,
        payload: restoreState.assets,
      });
    }

    if (restoreState.modals) {
      dispatch({
        type: RESTORE_MODALS,
        payload: restoreState.modals,
      });
    }

    if (restoreState.routeHistory) {
      dispatch({
        type: RESTORE_ROUTE_HISTORY,
        payload: restoreState.routeHistory,
      });
    }

    if (restoreState.orders) {
      dispatch({
        type: RESTORE_ORDER_DATA,
        payload: restoreState.orders,
      });
    }

    if (restoreState.expireTimestamp) {
      dispatch({
        type: SET_EXPIRE_TIMESTAMP,
        payload: restoreState.expireTimestamp,
      });
    }

    return dispatch({ type: '' });
  };

export default restoreRedux;
